import { fetchWrapper, objectToQueryParams } from '../utils';

export class adminReports {
  static baseUrl = process.env.REACT_APP_BASE_API + 'admin/reports';

  static async getUsers(form) {
    const url = `${this.baseUrl}/users`
    return await fetchWrapper.post(url, form);
  }

  static async updateUser(form) {
    const url = `${this.baseUrl}/user-update`
    return await fetchWrapper.post(url, form);
  }

  static async getPayments(form) {
    const url = `${this.baseUrl}/payments`
    return await fetchWrapper.post(url, form);
  }

  static async updatePaymentStatus(form) {
    const url = `${this.baseUrl}/payments/status`
    return await fetchWrapper.post(url, form);
  }

}